export const STRAPI_DOMAIN = `https://strapi.cenergy.io`
export const API_DOMAIN = `https://api.cenergy.io`
export const GOOGLE_MAP_KEY = 'AIzaSyB5JHOU1dEnP2gnd-p4dxkcwjeioU-JpYI'
export const GOOGLE_RECAPTCHA_SITE_KEY = '6LdYD54lAAAAAGS5nWhrREnwcimDiTVJA9RVh_Tx'
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const NUMBER_REGEX = /^\d+(\.\d+)?$/